const baseMeasurementVideoPath = (
  moduleInfo,
  urlPath = window.location.pathname,
) => {
  const moduleId = Number(moduleInfo?.moduleId);
  if (moduleId !== 5) return "test_video.mp4";
  if (urlPath === "/rom-left-flexion") return "100/100.mp4";
  if (urlPath === "/rom-left-extension") return "200/200.mp4";
  if (urlPath === "/rom-right-flexion") return "300/300.mp4";
  if (urlPath === "/rom-right-extension") return "400/400.mp4";
  return "test_video.mp4";
};

export const appendTimestampToVideoPath = (
  videoPath,
  timestamp = Date.now(),
) => {
  const lastSlash = videoPath.lastIndexOf("/");
  const lastDot = videoPath.lastIndexOf(".");
  const hasExtension = lastDot > lastSlash;
  const base = hasExtension ? videoPath.slice(0, lastDot) : videoPath;
  const extension = hasExtension ? videoPath.slice(lastDot) : "";

  return `${base}_${timestamp}${extension}`;
};

export const getMeasurementVideoFileName = (
  moduleInfo,
  urlPath = window.location.pathname,
  timestamp = Date.now(),
) =>
  appendTimestampToVideoPath(
    baseMeasurementVideoPath(moduleInfo, urlPath),
    timestamp,
  );
